import { DefaultPageHeader } from 'layouts';
import type { UserBase } from 'models';
import { useGetMemberEntityBreadcrumb } from '../hooks';

type P = {
  member: UserBase;
};

const MemberCommunitiesHeader = ({ member }: P) => {
  const breadcrumbRoutes = useGetMemberEntityBreadcrumb({ entityScope: 'communities', member });

  return <DefaultPageHeader routes={breadcrumbRoutes} title="Joined communities" />;
};

export default MemberCommunitiesHeader;
